<template>
  <div>
    <Loading
      v-if="isLoading"
      loading-message="載入中..."
      :background-color="'#ffffff'"
    />

    <main>
      <div class="px-3">
        <h2 class="section-title mt-4">預選清單</h2>
        <p class="total-quantity">您的預選單共計<span class="total-quantity--emphasis">{{ totalQuantity }}</span>項商品</p>
        <div class="products">
          <div
            class="products__item"
            v-for="(preorderItem, index) in preorderItems"
            :key="index"
          >
            <img
              :src="preorderItem.image"
              class="products__item__photo"
            />
            <div class="products__item__title">
              {{ preorderItem.title }}
            </div>
            <div class="products__item__price" v-if="priceIsVisible">
              <template v-if="preorderItem.is_discounted">
                <span class="promoting">${{ applyThousandsSeperator(preorderItem.discounted_price) }}</span>
                <span class="original-price ml-2">$ {{ applyThousandsSeperator(preorderItem.original_price) }}</span>
              </template>
              <div v-else>${{ applyThousandsSeperator(preorderItem.original_price) }}</div>
            </div>
            <div class="products__item__price" v-if="pointIsVisible">
              <span class="price">{{ preorderItem.point }} 點</span>
            </div>
            <div class="products__item__description" v-html="preorderItem.description"></div>
            <div class="products__item__quantity">
              <b-form-spinbutton
                size="sm"
                inline
                :value="preorderItem.quantity"
                min="1"
                class="increment-disabled decrement-disabled"
              ></b-form-spinbutton>
            </div>
          </div>
        </div>

        <div class="divider mt-4 mb-1"></div>
        <div class="total-price" v-if="priceIsVisible">
          TOTAL
          <span class="total-price--emphasis ml-3 mr-2">
            {{ applyThousandsSeperator(totalPrice) }}
          </span>
          元
        </div>
        <div class="total-price" v-if="pointIsVisible">
          TOTAL
          <span class="total-price--emphasis ml-3 mr-2">
            {{ applyThousandsSeperator(totalPoints) }}
          </span>
          點
        </div>

        <div class="preorder-cart__terms mt-4" v-if="terms !== null" v-html="terms"></div>
      </div>

      <img class="w-100 mt-4" v-if="topImageUrl" :src="topImageUrl">

      <div class="px-3">
        <h2 class="shop-name mt-4">{{ deepGet(branch, 'name') }}</h2>
        <h2 class="section-title mt-4">個人資料</h2>
        <div class="dynamic-form mt-4">
          <DynamicForm ref="checkoutForm" :input-subjects="fields" :value="dynamicFormValues" />
        </div>
      </div>

      <img class="w-100 mt-4" v-if="bottomImageUrl" :src="bottomImageUrl">
    </main>

    <footer class="sticky-bottom footer-action-bar">
      <!-- <ShareButton
        class="footer-action-bar__checkout-button"
        variant="s-btn-outline-primary bg-transparent"
      >
        返回前頁
      </ShareButton>
      <ShareButton
        class="footer-action-bar__checkout-button"
        variant="primary"
      >
        送出訂單
      </ShareButton> -->
    </footer>
  </div>
</template>

<script>
import preorderApi from "@/apis/liff/v2/preorder";
import DynamicForm from "@/components/DynamicForm/DynamicForm";
// import ShareButton from "@/components/Page/Liff/Shared/Button";
import Loading from "@/components/Page/Liff/Shared/Loading";
import themeColor from "@/mixins/liff/themeColor";
import DynamicFormField from "@/models/DynamicFormField.model"
import PreorderSetting from "@/models/PreorderSetting.model"
// import Sku from "@/models/Sku.model"
import { applyThousandsSeperator } from "@/utils/numberUtils";
import _ from "lodash"

export default {
  mixins: [themeColor],
  components: {
    DynamicForm,
    // ShareButton,
    Loading,
  },
  data() {
    return {
      isLoading: true,
      preorderSetting: null,
      preorder: null,
    };
  },
  computed: {
    preorderSettingId() {
      return this.$route.params.preorderSettingId
    },
    preorderId() {
      return this.$route.params.preorderId
    },
    branch() {
      return _.get(this.preorder, 'branch', null)
    },
    preorderSettingDataModel() {
      return new PreorderSetting(this.preorderSetting)
    },
    preorderItems() {
      return _.get(this.preorder, 'items', []).map(preorderItem => {
        return {
          id: preorderItem.id,
          title: preorderItem.title,
          description: _.chain(preorderItem).get('product.description').defaultTo('').replace(/\n/g, "<br>"),
          original_price: preorderItem.price,
          discounted_price: preorderItem.price,
          is_discounted: false,
          point: preorderItem.points,
          image: _.get(preorderItem, 'product.images[0].pic_url', null),
          quantity: preorderItem.quantity,
        }
      })
    },
    fields() {
      return DynamicFormField.fromArray(_.get(this.preorderSetting, 'config.fields', []))
        .map((fieldModel) => ({
          ...fieldModel.flattenedAttributes(),
          disabled: true,
        }))
    },
    dynamicFormValues() {
      return _.get(this.preorder, 'data', []).reduce((acc, data) => {
        return { ...acc, [data.field_id]: data.value }
      }, {})
    },
    priceIsVisible() {
      return this.preorderSettingDataModel.isMoneyMode
    },
    pointIsVisible() {
      return this.preorderSettingDataModel.isPointMode
    },
    totalPrice() {
      return _.get(this.preorder, 'total_amount', 0)
    },
    totalPoints() {
      return _.get(this.preorder, 'total_points', 0)
    },
    totalQuantity() {
      return _.sumBy(this.preorderItems, 'quantity')
    },
    topImageUrl() {
      return _.get(this.preorderSetting, 'config.confirm_page.top_image_url')
    },
    bottomImageUrl() {
      return _.get(this.preorderSetting, 'config.confirm_page.bottom_image_url')
    },
    terms() {
      return _.get(this.preorderSetting, 'config.confirm_page.terms', null)
    },
  },
  async mounted() {
    await Promise.all([
      this.fetchPreorderConfiguration(),
      this.fetchPreorderRecord(),
    ])
    this.isLoading = false
  },
  methods: {
    applyThousandsSeperator,
    deepGet: _.get,
    async fetchPreorderConfiguration() {
      this.preorderSetting = _.get(await preorderApi.fetchConfiguration(this.preorderSettingId), 'data.data', null)
    },
    async fetchPreorderRecord() {
      this.preorder = _.get(await preorderApi.fetchRecord(this.preorderId), 'data', null)
    },
  },
};
</script>

<style lang="scss" scoped>
.products {
  &__item + &__item {
    margin-top: 16px;
  }

  &__item {
    color: #212121;
    background-color: white;
    text-decoration: none !important;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto auto auto 1fr;
    grid-template-areas:
      "photo title"
      "photo price"
      "photo description"
      "photo quantity";

    &__photo {
      grid-area: photo;
      width: clamp(120px, 33vw, 240px);
      object-fit: cover;
      aspect-ratio: 1 / 1.2;

      @media screen and (min-width: 512px) {
        width: clamp(120px, 25vw, 240px);
      }
    }

    &__title {
      grid-area: title;
      display: -webkit-box;
      margin-top: 16px;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__price {
      grid-area: price;
      margin-top: 8px;
      font-size: 0.875rem;
      color: #aaa;

      .promoting {
        font-size: 1rem;
        font-weight: normal;
        color: var(--primary-color);
      }

      .original-price {
        text-decoration: line-through;
        color: #aaa;
      }
    }

    &__description {
      grid-area: description;
      display: -webkit-box;
      margin-top: 8px;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 0.875rem;
      color: #888;
    }

    &__quantity {
      grid-area: quantity;
      display: flex;
      margin-top: 8px;
      margin-bottom: 16px;
      align-items: flex-end;

      ::v-deep .b-form-spinbutton {
        height: 36px;
        padding: 0;

        output {
          text-align: center !important;
        }
      }
    }

    &__title, &__price, &__description, &__quantity {
      padding: 0 16px;
    }
  }
}

.shop-name {
  padding: 16px;
  background-color: #f8f8f8;
  font-size: 1.1rem;
  font-weight: 500;
  color: #444;
  text-align: center;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 500;
  color: #444;
  text-align: center;
}

.total-quantity {
  color: #777;
  text-align: center;

  &--emphasis {
    margin: 0 8px;
    font-size: 1.25rem;
    font-weight: 500;
    color: #444;
  }
}

.total-price {
  font-size: .875rem;
  color: #444;
  text-align: right;

  &--emphasis {
    font-size: 1.5rem;
  }
}

.preorder-cart__terms {
  padding: 16px;
  background-color: #f8f8f8;
}

.divider {
  height: 1px;
  width: 100%;
  background-color: #ccc;
}

.footer-action-bar {
  max-width: 768px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background-color: white;
  box-shadow: 0px -2px 4px 0px #0000000D;

  &__checkout-button {
    flex: 0 1 50%;
    padding: 12px;
  }

  &__checkout-button + &__checkout-button {
    margin-left: 16px;
  }
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
}


::v-deep .form-check-input{
  margin:3px 3px 0px 4px;
}

::v-deep .form-check{
  margin-top: 0;
}

::v-deep .increment-disabled [aria-label="Increment"] {
  opacity: 0.3;
  pointer-events: none;
}

::v-deep .decrement-disabled [aria-label="Decrement"] {
  opacity: 0.3;
  pointer-events: none;
}
</style>
